import React, { useEffect, useState, useRef } from "react";
import PageHeader from "../pageHeader/pageHeader";
import { Select, DatePicker } from "antd";
import { DeleteFilled, UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import across from "../../../imgs/across.png";
import logo from "../../../imgs/logo12.png";
import { useSelector, useDispatch } from "react-redux";
import check from "../../../imgs/add.png";
import { message } from "antd";
import moment from "moment";
import img from "../../../imgs/impLogo.png";
import thumb from "../../../imgs/Thumb.png";
import ff from "../../../constants/country";
import { useNavigate } from "react-router-dom";
import { detectObjectsInImage } from "../../../utlis/modelLoader";
import FaceVerificatioNModal from "../../../utlis/FaceVerficationLoaderModal";
let file;
let rr;
const SelectLocation = () => {
  const router = useNavigate();
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const [imageUrl, setImageUrl] = useState("");
  const [previousImage, setPreviousImage] = useState("");
  const [messageApi] = message.useMessage();
  const penVerStatus = useSelector((state) => state.penVerStatus);
  const progId = useSelector((state) => state.progId);
  const [notHuman, setNotHuman] = useState(false);
  const [url, setUrl] = useState("");
  const [verify, setVerify] = useState(false);
  const faceApi = useSelector((state) => state.faceApi);
  const token = useSelector((state) => state.token);
  const [display, setDisplay] = useState(
    "data:image/png;base64,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"
  );
  const option = useSelector((state) => state.option);
  const [age1, setAge1] = useState("");
  const [title, setTitle] = useState("");
  const [displaysig, setDisplaysig] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [callName, setCallName] = useState("");
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("");
  const [email, setEmail] = useState("");
  const [type, setType] = useState(true);
  const [ethnicity, setEthnicity] = useState("");
  const [note, setNote] = useState("");
  const [unionStatus, setUnionStatus] = useState("");
  const [employmentStatus, setEmploymentStatus] = useState("retired");
  const [nationality, setNationality] = useState("Guyanese");
  const veriSelectedPensioner = useSelector(
    (state) => state.veriSelectedPensioner
  );
  const [show, setShow] = useState(false);
  const [showVer, setShowVer] = useState(false);
  const [err, setErr] = useState("");
  const reset = useSelector((state) => state.reset);
  const dataUser = useSelector((state) => state.dataUser);
  const profileData = useSelector((state) => state?.profileData);
  const [religion, setReligion] = useState("");
  const [homePhone, setHomePhone] = useState("");
  const [workPhone, setWorkPhone] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [note1, setNote1] = useState("");
  rr = ff.map((item) => {
    return {
      lable: `${item}`,
      value: `${item}`,
    };
  });
  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/v1/users/pensioner-profile/${veriSelectedPensioner?.id}`,
        {
          headers: {
            Authorization: `Bearer ${dataUser.data.tokens.access.token}`,
          },
        }
      )
      .then((data) => {
        dispatch({ type: "setProfileData", num: data.data });
      })
      .catch(() => {});
  }, [reset]);
  useEffect(() => {
    console.log("ProfileData", profileData);
    setTitle(profileData?.person?.title);
    setFirstName(profileData?.person?.firstName);
    setLastName(profileData?.person?.lastName);
    setMiddleName(profileData?.person?.middleName);
    setCallName(profileData?.person?.callName);
    setDob(profileData?.person?.dateOfBirth);
    setGender(profileData?.person?.gender);
    setEthnicity(profileData?.person?.ethnicity);
    setUnionStatus(profileData?.person?.unionStatus);
    setEmploymentStatus(profileData?.person?.employmentStatus);
    setNationality(profileData?.person?.nationality);
    setReligion(profileData?.person?.religion);
    setHomePhone(profileData?.person?.homePhone);
    setWorkPhone(profileData?.person?.workPhone);
    setEmail(profileData?.person?.email);
    setDisplay(profileData?.person?.image);
    setImageUrl(profileData?.person?.image);
    if (profileData?.pensionerInfo?.signature !== null) {
      setUrl(profileData?.pensionerInfo?.signature);
      axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/v1/file/get-image-url?fileType=document`,
          {
            fileNames: [profileData?.pensionerInfo?.signature],
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((data) => {
          setDisplaysig(data.data[0].url);
        })
        .catch(() => {});
    } else {
      setDisplaysig("");
      setUrl("");
    }
  }, [profileData]);
  const handleChange = (setState, check) => (event) => {
    if (check === "tt") {
      if (event) {
        // setAllow(false);
        const birthDate = event.$d;
        var today = new Date();
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        setAge1(age);
        if (age === 64) {
          const tod = today.getMonth() + 1;
          const earl = birthDate.getMonth() + 1;
          const fil = tod - earl;

          if (12 - fil <= 3) {
            // setAllow(true);
          }
        }
        let wow;
        if (event.$M <= 9) {
          if (event.$D <= 9) {
            wow = `${event.$y}-0${Number(event.$M) + 1}-0${event.$D}`;
          } else {
            wow = `${event.$y}-0${Number(event.$M) + 1}-${event.$D}`;
          }
        } else {
          if (event.$D <= 9) {
            wow = `${event.$y}-${Number(event.$M) + 1}-0${event.$D}`;
          } else {
            wow = `${event.$y}-${Number(event.$M) + 1}-${event.$D}`;
          }
        }
        setDob(wow);
      } else if (event === null) {
        setAge1("");
      }
    } else if (check === "tg") {
      setState(event);
    } else {
      setState(event.target.value);
    }
  };
  const FaceError = () => {
    messageApi.open({
      // type: 'success',
      content: (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img src={img} alt="mage" width="50" height="50" />
          <h3>
            Please upload your profile image again; it's not verified as a human
            face.
          </h3>
        </div>
      ),
      duration: 6,
    });
  };
  const calculateFileHash = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = async (e) => {
        const buffer = e.target.result;
        const cryptoKey = await crypto.subtle.digest("SHA-256", buffer);
        const hashArray = Array.from(new Uint8Array(cryptoKey));
        const hashHex = hashArray
          .map((byte) => byte.toString(16).padStart(2, "0"))
          .join("");
        resolve(hashHex);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsArrayBuffer(file);
    });
  };
  const imageHandler = async (e) => {
    const file = e.target.files[0];
    const newImageHash = await calculateFileHash(file);

    if (newImageHash === previousImage && notHuman === true) {
      FaceError();
      fileInputRef.current.value = null;
      return;
    }

    if (file) {
      dispatch({ type: "FACE_API", num: true });
      const detectedObjects = await detectObjectsInImage(file);
      // setObjects(detectedObjects);

      const hasHuman = detectedObjects.some(
        (object) => object.class === "person"
      );
      dispatch({ type: "FACE_API", num: false });
      if (hasHuman) {
        setNotHuman(false);
        imageUploder(e);
        console.log("The image contains a human.");
      } else {
        setNotHuman(true);
        setPreviousImage(newImageHash);
        FaceError();
        console.log("The image does not contain a human.");
      }
      fileInputRef.current.value = null;
    }
  };

  const imageUploder = async (e) => {
    file = e.target.files[0];
    const base641 = await convertToBase64(file);
    setDisplay(base641);
    var bodyFormData = new FormData();
    bodyFormData.append("file", file);
    axios({
      method: "post",
      url: `${process.env.REACT_APP_BASE_URL}/v1/file/images?fileType=profile`,
      data: bodyFormData,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((data) => {
        setImageUrl(data.data.url);
      })
      .catch(() => {});
  };
  function convertToBase64(file) {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  }
  function getCurrentDate(separator = "") {
    let newDate = new Date();
    let date_raw = newDate.getDate();
    let month_raw = newDate.getMonth() + 1;
    let year = newDate.getFullYear();
    var date, month;

    if (date_raw < 10) {
      date = "0" + date_raw.toString();
    } else {
      date = date_raw.toString();
    }
    if (month_raw < 10) {
      month = "0" + month_raw.toString();
    } else {
      month = month_raw.toString();
    }
    return (
      <div>
        {year}
        {separator}
        {month}
        {separator}
        {date}
      </div>
    );
  }
  const date1 = getCurrentDate();
  const disabledBeforeDate1 = moment(
    `${date1.props.children[0]}-${date1.props.children[2]}-${date1.props.children[4]}`
  );
  const disabledDate1 = (current) => {
    return current && current > disabledBeforeDate1;
  };
  const imageHandlerr = async (e) => {
    file = e.target.files[0];
    console.log("Fileee", file);
    const base641 = await convertToBase64(file);
    setDisplaysig(base641);
    console.log("base", base641);
    var bodyFormData = new FormData();
    bodyFormData.append("file", file);
    axios({
      method: "post",
      url: `${process.env.REACT_APP_BASE_URL}/v1/file/images?fileType=document`,
      data: bodyFormData,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((data) => {
        setUrl(data.data.url);
      })
      .catch(() => {});
  };
  useEffect(() => {
    console.log("test", dob);
    if (dob) {
      const dobD = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - dobD.getFullYear();
      const m = today.getMonth() - dobD.getMonth();

      if (m < 0 || (m === 0 && today.getDate() < dobD.getDate())) {
        age--;
      }

      setAge1(age);
    }
  }, [dob]);

  const updateHandler = () => {
    setShowVer(false);
    let body1 = {
      title: title,
      image: imageUrl,
      firstName: firstName,
      lastName: lastName,
      dateOfBirth: dob,
      ethnicity: ethnicity,
      unionStatus: unionStatus,
      employmentStatus: employmentStatus,
      nationality: nationality,
      religion: religion,
    };
    if (callName) body1.callName = callName;
    if (workPhone) body1.workPhone = workPhone;
    if (homePhone) body1.homePhone = homePhone;
    if (middleName) body1.middleName = middleName;
    // if (email !== "") body1.person.callName = callName;
    axios
      .put(
        `${process.env.REACT_APP_BASE_URL}/v1/persons/update-by-staff?userId=${veriSelectedPensioner?.id}`,
        {
          person: body1,
        },
        {
          headers: {
            Authorization: `Bearer ${dataUser?.data?.tokens?.access?.token}`,
          },
        }
      )
      .then(() => {
        // dispatch({ type: "RESET" });
        // Verification();
        SigUpdate();
      })
      .catch((err) => {
        setErr(err.response.data.message);
        setShow(true);
      });
  };
  const Verification = () => {
    let body;
    body = {
      pensionprogramId: progId,
      verificationStatus: type
        ? "Basic Detail Verified"
        : "Verification Rejected",
    };
    if (!type) body.note = note1;
    else if (type) {
      if (note1 !== "") body.note = note1;
    }
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/v1/user-verifications/change-status?userId=${veriSelectedPensioner?.id}`,
        body,
        {
          headers: {
            Authorization: `Bearer ${dataUser.data.tokens.access.token}`,
          },
        }
      )
      .then(() => {
        setShowVer(false);
        router("/pensionerVerification/Profile");
        if (type)
          dispatch({
            type: "PEN_VER_STATUS",
            num: "Basic Detail Verified",
          });
        else {
          dispatch({
            type: "PEN_VER_STATUS",
            num: "Verification Rejected",
          });
          dispatch({
            type: "PEN_REJECT_NOTE",
            num: note1,
          });
        }
      })
      .catch((err) => {
        setShowVer(false);
        setErr(err.response.data.message);
        setShow(true);
      });
  };
  const SigUpdate = () => {
    let body;
    let method;
    let api;
    if (profileData?.pensionerInfo?.signature !== null) {
      api = `${process.env.REACT_APP_BASE_URL}/v1/pensioner-info/${profileData?.pensionerInfo?.id}/update-by-staff`;
      method = "put";
      body = {
        pensionerInfo: {
          signature: url,
        },
        consumerInfo: {
          ip: "hhh.hh.h.h",
          location: "14.37854898945,38.9409095",
        },
      };
    } else {
      api = `${process.env.REACT_APP_BASE_URL}/v1/pensioner-info/add-by-staff?pensionerUserId=${profileData?.user?.id}`;
      method = "put";
      body = {
        pensionerInfo: {
          signature: url,
        },
        consumerInfo: {
          ip: "zzz.zz.z.z",
          location: "14.37854898945,38.9409095",
        },
      };
    }
    axios({
      method: method,
      url: api,
      data: body,
      headers: {
        Authorization: `Bearer ${dataUser.data.tokens.access.token}`,
      },
    })
      .then(() => {
        dispatch({ type: "RESET" });
        Verification();
      })
      .catch((err) => {
        setErr(err.response.data.message);
        setShow(true);
      });
  };
  return (
    <div className="bg-[#ebfff3]  flex flex-col p-6 min-h-screen">
      <PageHeader header={true} title={"Verify Basic info"} route={-1} />
      <div className="flex justify-center">
        <div
          className={`bg-[#fafaf9] shadow-lg rounded-sm sm:mx-20 mx-2 m-5 p-6 sm:w-[90%] w-full`}
        >
          <div className="flex items-center justify-center mb-4">
            <label
              htmlFor="special-input"
              className={`${
                penVerStatus === "Verification Pending" ||
                penVerStatus === "Verification Rejected"
                  ? "cursor-pointer relative"
                  : "pointer-events-none relative"
              }`}
            >
              <div className="relative w-[8.5rem] h-[8.5rem] overflow-hidden border-2 border-[#686262]  rounded-full mb-4 ">
                <img
                  className="object-cover w-[8.5rem] h-[8.5rem]"
                  src={display}
                  alt=""
                />
              </div>

              <div
                className={`bg-primary rounded-full absolute bottom-4 right-2 ${
                  penVerStatus === "Verification Pending" ? "block" : "hidden"
                }`}
              >
                <img src={check} className="lg:w-7 w-5" alt="" />
              </div>
              <input
                type="file"
                className="hidden"
                id="special-input"
                accept="image/png, image/gif, image/jpeg"
                // onInput={imageHandler}
                onChange={imageHandler}
                ref={fileInputRef}
              />
            </label>
          </div>
          <div
            className={` ${
              penVerStatus === "Verification Pending" ||
              penVerStatus === "Verification Rejected"
                ? "flex justify-center items-center flex-col"
                : "pointer-events-none flex justify-center items-center flex-col"
            }`}
          >
            <div className="grid sm:grid-cols-2 sm:gap-4 grid-cols-1 sm:w-[80%] w-[90%]">
              <div className="w-[100%]">
                <div className="flex flex-col">
                  <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                    Title
                  </label>
                  <Select
                    placeholder="Title"
                    optionFilterProp="children"
                    className="wow"
                    value={title}
                    style={{ marginBottom: "1.2rem" }}
                    onChange={handleChange(setTitle, "tg")}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    size="middle"
                    options={[
                      {
                        value: "Mr.",
                        label: "Mr.",
                      },
                      {
                        value: "Mrs.",
                        label: "Mrs.",
                      },
                      {
                        value: "Miss.",
                        label: "Miss.",
                      },
                    ]}
                  />
                </div>
                <div className="flex flex-col">
                  <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                    First Name
                  </label>
                  <input
                    type="text"
                    name=""
                    onChange={handleChange(setFirstName)}
                    value={firstName}
                    placeholder="First Name"
                    className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                  />
                </div>
                <div className="flex flex-col">
                  <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                    Middle Name
                  </label>
                  <input
                    type="text"
                    name=""
                    onChange={handleChange(setMiddleName)}
                    value={middleName}
                    placeholder="Middle Name"
                    className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                  />
                </div>
                <div className="flex flex-col">
                  <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                    Last Name
                  </label>
                  <input
                    type="text"
                    name=""
                    onChange={handleChange(setLastName)}
                    value={lastName}
                    placeholder="Last Name"
                    className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                  />
                </div>

                <div className="flex flex-col">
                  <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                    AKA / Call Name
                  </label>
                  <input
                    type="text"
                    name=""
                    onChange={handleChange(setCallName)}
                    value={callName}
                    placeholder="AKA / Call Name"
                    className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                  />
                </div>
                <div className="flex flex-col">
                  <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                    Date of Birth
                  </label>
                  <DatePicker
                    style={{ marginBottom: "1.2rem" }}
                    disabledDate={disabledDate1}
                    className="date-class"
                    onChange={handleChange(dob, "tt")}
                    value={dob ? dayjs(dob) : null}
                  />
                </div>
                <div className="flex flex-col">
                  <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                    Age
                  </label>
                  <input
                    style={{ marginBottom: "1.2rem" }}
                    className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                    value={`${age1 === "" ? "" : `${age1} year`}`}
                    onChange={(value) => {
                      if (value < 16) {
                        setErrorMessage("Age must be at least 16 years.");
                      } else {
                        setErrorMessage("");
                      }
                    }}
                    placeholder="Age"
                  />
                  {errorMessage}
                </div>
              </div>
              <div>
                <div className="flex flex-col">
                  <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                    Gender
                  </label>
                  <Select
                    placeholder="Gender"
                    optionFilterProp="children"
                    className="wow"
                    style={{ marginBottom: "1.2rem" }}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    size="middle"
                    value={gender}
                    onChange={handleChange(setGender, "tg")}
                    options={[
                      {
                        value: "Male",
                        label: "Male",
                      },
                      {
                        value: "Female",
                        label: "Female",
                      },
                      {
                        value: "Non-Binary",
                        label: "Non-Binary",
                      },
                      {
                        value: "Transgender",
                        label: "Transgender",
                      },
                    ]}
                  />
                </div>
                <div className="flex flex-col">
                  <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                    Ethnicity
                  </label>
                  <Select
                    placeholder="Ethnicity"
                    optionFilterProp="children"
                    className="wow"
                    style={{ marginBottom: "1.1rem" }}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    size="middle"
                    value={ethnicity}
                    onChange={handleChange(setEthnicity, "tg")}
                    options={[
                      {
                        value: "African",
                        label: "African",
                      },
                      {
                        value: "Amerindian",
                        label: "Amerindian",
                      },
                      {
                        value: "Chinese",
                        label: "Chinese",
                      },
                      {
                        value: "East Indian",
                        label: "East Indian",
                      },
                      {
                        value: "European",
                        label: "European",
                      },
                      {
                        value: "Mixed Race",
                        label: "Mixed Race",
                      },
                      {
                        value: "Portuguese",
                        label: "Portuguese",
                      },
                      {
                        value: "Other",
                        label: "Other",
                      },
                    ]}
                  />
                </div>
                <div className="flex flex-col">
                  <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                    Marital Status
                  </label>
                  <Select
                    placeholder="Marital Status"
                    optionFilterProp="children"
                    className="wow"
                    value={unionStatus}
                    style={{ marginBottom: "1.1rem" }}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    size="middle"
                    onChange={handleChange(setUnionStatus, "tg")}
                    options={[
                      {
                        value: "common law",
                        label: "Common Law",
                      },
                      {
                        value: "divorced",
                        label: "Divorced",
                      },
                      {
                        value: "married",
                        label: "Married",
                      },
                      {
                        value: "separated",
                        label: "Separated",
                      },
                      {
                        value: "single",
                        label: "Single",
                      },
                      {
                        value: "visiting relation",
                        label: "Visiting Relation",
                      },
                      {
                        value: "widowed",
                        label: "Widowed",
                      },
                    ]}
                  />
                </div>
                <div className={`flex flex-col`}>
                  <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                    Employment Status
                  </label>
                  <Select
                    placeholder="Employment Status"
                    optionFilterProp="children"
                    className="wow"
                    value={employmentStatus}
                    style={{ marginBottom: "1rem" }}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    size="middle"
                    onChange={handleChange(setEmploymentStatus, "tg")}
                    options={[
                      {
                        value: "employed",
                        label: "Employed",
                      },
                      {
                        value: "retired",
                        label: "Retired",
                      },
                      {
                        value: "unemployed",
                        label: "Un-Employed",
                      },
                    ]}
                  />
                </div>
                <div className="flex flex-col">
                  <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                    Nationality
                  </label>
                  <Select
                    placeholder="Nationality"
                    showSearch
                    value={nationality}
                    className="wow"
                    onChange={handleChange(setNationality, "tg")}
                    optionFilterProp="children"
                    style={{
                      marginBottom: option === "Employee" ? "1rem" : "1.1rem",
                    }}
                    filterOption={(input, option) =>
                      (option?.lable ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    size="middle"
                    options={rr}
                  />
                </div>
                <div className="flex flex-col">
                  <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                    Religion
                  </label>
                  <Select
                    placeholder="Religion"
                    optionFilterProp="children"
                    className="wow"
                    style={{ marginBottom: "0.9rem" }}
                    onChange={handleChange(setReligion, "tg")}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    size="middle"
                    value={religion}
                    showSearch
                    options={[
                      {
                        value: "Affrican Traditional Religions",
                        label: "Affrican Traditional Religions",
                      },
                      {
                        value: "Animism",
                        label: "Animism",
                      },
                      {
                        value: "Baha",
                        label: "Baha",
                      },
                      {
                        value: "Buddhism",
                        label: "Buddhism",
                      },
                      {
                        value: "Cao Dai",
                        label: "Cao Dai",
                      },
                      {
                        value: "Chinese traditional religion",
                        label: "Chinese traditional religion",
                      },
                      {
                        value: "Christianity",
                        label: "Christianity",
                      },
                      {
                        value: "Islam",
                        label: "Islam",
                      },
                      {
                        value: "Jainism",
                        label: "Jainism",
                      },
                      {
                        value: "Judaism",
                        label: "Judaism",
                      },
                      {
                        value: "Neo-Paganism",
                        label: "Neo-Paganism",
                      },
                      {
                        value: "Rastafari",
                        label: "Rastafari",
                      },
                      {
                        value: "Secular/Nonreligious/Agnostic/Atheist",
                        label: "Secular/Nonreligious/Agnostic/Atheist",
                      },
                      {
                        value: "Shinto",
                        label: "Shinto",
                      },
                      {
                        value: "Sikhism",
                        label: "Sikhism",
                      },
                      {
                        value: "Spiritism",
                        label: "Spiritism",
                      },
                      {
                        value: "Tenrikyo",
                        label: "Tenrikyo",
                      },
                      {
                        value: "Unitarian Universalism",
                        label: "Unitarian Universalism",
                      },
                      {
                        value: "Zoroastrianism",
                        label: "Zoroastrianism",
                      },
                      {
                        value: "Others",
                        label: "Others",
                      },
                    ]}
                  />
                </div>

                

                <div className="flex flex-col">
                  <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                    Other Contact Detail
                  </label>
                  <input
                    type="text"
                    // onChange={handleChange(setHomePhone)}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      if (/^\+?[0-9()-]*$/.test(inputValue)) {
                        setHomePhone(inputValue);
                      }
                    }}
                    value={homePhone}
                    placeholder="Home Phone Number"
                    className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                  />
                  <input
                    type="text"
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      if (/^\+?[0-9()-]*$/.test(inputValue)) {
                        setWorkPhone(inputValue);
                      }
                    }}
                    value={workPhone}
                    placeholder="Work Phone Number"
                    className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                  />
                  <input
                    type="text"
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                    value={email}
                    placeholder="Email Address"
                    className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                  />
                </div>
              </div>
            </div>
            <label className="text-[#596F96] sm:w-[80%] w-[90%] text-[0.88rem] mt-4 font-semibold mb-2">
              Update Signature/Fingerprint
            </label>
            <div className="sm:w-[80%] w-[90%] bg-white flex items-center p-4 justify-center">
              <div
                className={`flex items-center justify-center rounded-lg text-center sm:w-[23rem] w-full h-[13rem] relative`}
              >
                {displaysig ? (
                  <>
                    <img
                      src={displaysig}
                      alt="Uploaded"
                      className="w-full h-full"
                    />
                    <button
                      className="absolute bottom-1 right-1"
                      onClick={() => {
                        setUrl("");
                        setDisplaysig("");
                      }}
                    >
                      <DeleteFilled
                        className={`${
                          penVerStatus === "Verification Pending"
                            ? "text-2xl text-primary cursor-pointer"
                            : "hidden"
                        }`}
                      />
                    </button>
                  </>
                ) : (
                  <div className="w-full h-full flex flex-col gap-1 flex bg-gray-100 p-4 items-center justify-center">
                    <div className="flex items-center w-full justify-center flex-col">
                      <UploadOutlined className="text-4xl text-primary cursor-pointer " />
                      <label
                        htmlFor="file-upload"
                        className="text-5xl text-primary w-full cursor-pointer flex flex-col gap-2 items-center justify-center"
                      >
                        <input
                          id="file-upload"
                          type="file"
                          className="hidden"
                          accept="image/*"
                          onChange={(e) => imageHandlerr(e)}
                        />
                        <div className="mt-4 w-[80%] text-sm p-2 cursor-pointer text-center bg-white border-primary text-primary border-2  px-4 rounded-lg">
                          Upload
                        </div>
                      </label>
                    </div>
                  </div>
                )}
              </div>
            </div>
            {(penVerStatus === "Verification Pending" ||
              penVerStatus === "Verification Rejected") && (
              <div
                className={`flex w-[80%] items-center justify-center mt-6 gap-2 mb-5`}
              >
                <button
                  type="button"
                  onClick={() => {
                    // Update();
                    // router("/pensionerVerification/Profile");
                    if (url === "") {
                      setErr("Please Upload Signature");
                      setShow(true);
                    } else {
                      setShowVer(true);
                      setType(true);
                    }
                    setShowVer(true);
                  }}
                  className={`lg:text-[1rem] bg-gradient-to-tr  bg-primary text-white rounded-[0.5rem] p-2  pr-8 pl-8 `}
                >
                  Update and verified
                </button>
                <button
                  type="button"
                  onClick={() => {
                    // router("/pensionerVerification/Profile");
                    setShowVer(true);
                    setType(false);
                  }}
                  className={`lg:text-[1rem] bg-gradient-to-tr  bg-red-600 text-white rounded-[0.5rem] p-2  pr-8 pl-8`}
                >
                  Unverified
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      {faceApi === true && <FaceVerificatioNModal />}
      <div
        className={`${
          verify ? "" : "hidden"
        } fixed top-0 left-0 w-screen h-screen z-50 flex justify-center items-center bg-black bg-opacity-50`}
      >
        <div className="relative rounded-xl w-[25rem] pb-6 pt-4 flex items-center p-3 bg-white flex-col">
          <div className="w-[4rem] h-[4rem] p-3 flex items-center justify-center bg-primary rounded-full">
            <img src={thumb} alt="" className="w-full h-full" />
          </div>
          <h1 className="font-bold mt-2 text-primary">Basic info verified</h1>
          <p className="text-center w-[90%] text-[#757575] mt-[1rem] mb-2">
            The pensioner has been successfully verified by you. Would you like
            to add any notes here.
          </p>
          <div className="flex flex-col w-[85%]">
            <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
              Note
            </label>
            <textarea
              type="text"
              name=""
              onChange={(e) => setNote(e.target.value)}
              value={note}
              placeholder="Type Note Here..."
              className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
            />
          </div>
          <div className="w-[85%] flex items-center justify-center gap-2">
            <button
              onClick={() => {
                setVerify(false);
              }}
              className="cursor-pointer rounded-xl pt-[0.5rem] pb-[0.5rem] pl-10 pr-10 text-white bg-red-600 w-[50%]"
            >
              Cancel
            </button>

            <button
              onClick={() => {
                router("/pensionerVerification/Profile");
                setVerify(false);
              }}
              className="cursor-pointer rounded-xl pt-[0.5rem] pb-[0.5rem] pl-10 pr-10 text-white bg-primary w-[50%]"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
      <div
        className={`${
          show ? "" : "hidden"
        } w-[100%] h-[100%] z-[100] fixed top-0 left-0 bg-slate-500/50 flex justify-center items-center`}
      >
        <div className="relative rounded-xl w-[20rem] pb-6 flex items-center p-3 bg-white flex-col">
          <div
            className="absolute top-[-11%] left-[42%]"
            onClick={() => setShow(false)}
          >
            <img src={across} alt="" />
          </div>
          <p className="text-center mt-[3rem] mb-5">{err}</p>
          <button
            onClick={() => setShow(false)}
            className="cursor-pointer rounded-xl pt-[0.5rem] pb-[0.5rem] pl-10 pr-10 text-white bg-[#DE2827] w-[60%]"
          >
            Ok
          </button>
        </div>
      </div>
      <div
        className={`${
          showVer ? "" : "hidden"
        } w-[100%] h-[100%] fixed top-0 left-0 bg-slate-500/50 flex justify-center items-center`}
      >
        <div className="relative rounded-xl w-[26rem]  flex items-center p-5 bg-white flex-col">
          <div className="w-16 h-16" onClick={() => setShowVer(false)}>
            <img src={logo} alt="" className="w-16 h-16" />
          </div>
          {type ? (
            <p className="text-center mt-6 mb-5 font-semibold">
              Are you sure to mark this pensioner as verified?
            </p>
          ) : (
            <p className="text-center mt-6 mb-5 font-semibold">
              Are you sure to reject this Pensioner?
            </p>
          )}
          <textarea
            type="text"
            name=""
            onChange={(e) => setNote1(e.target.value)}
            value={note1}
            placeholder="Note"
            className=" lg:text-[1.1rem] w-[85%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
          />
          <div className="w-full flex gap-2 items-center justify-center">
            <button
              onClick={() => setShowVer(false)}
              className="cursor-pointer rounded-xl pt-[0.5rem] pb-[0.5rem] pl-10 pr-10 text-white bg-[#DE2827] w-[40%]"
            >
              No
            </button>
            <button
              onClick={() => {
                if (note1 === "" && !type) {
                  setErr("Please Add Note");
                  setShow(true);
                  return;
                }
                if (type) updateHandler();
                else Verification();
              }}
              className="cursor-pointer rounded-xl pt-[0.5rem] pb-[0.5rem] pl-10 pr-10 text-white bg-primary w-[40%]"
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectLocation;
